export default "__VITE_ASSET__B49oO_5z__"